import React from 'react';
import PropTypes from 'prop-types';

import PermissionDeniedTooltip from '~/components/core/Permissions/PermissionDeniedTooltip';
import { useRestrictedPermissions } from '~/components/core/Permissions/RestrictedPermissions';
import Radio, { SIZES as RADIO_SIZES } from '~/components/ui/atoms/Radio';

import { FsWrappersSharedProptypes, getEnumObjectFromArray } from '../FsWrappersUtils';

export const FsRadio = ({ checked, name, onChange, disabled, size, onClick, ignorePermissions }) => {
  const { userHasContextPermissions } = useRestrictedPermissions();
  const hasPermissions = ignorePermissions || userHasContextPermissions;
  const isDisabled = disabled || !hasPermissions;

  // A disabled radio blocks pointer events; the permission tooltip still fires, because FsTooltip
  // listens on a span of its own around it.
  const radioButton = (
    <Radio
      checked={checked}
      name={name}
      onChange={onChange}
      disabled={isDisabled}
      // `small` is this wrapper's name for the Radio's 15px size, `xs`.
      size={size === FsRadio.SIZES.small ? RADIO_SIZES.xs : RADIO_SIZES.medium}
      onClick={onClick}
    />
  );

  if (hasPermissions) {
    return radioButton;
  }

  return <PermissionDeniedTooltip>{radioButton}</PermissionDeniedTooltip>;
};

FsRadio.SIZES = getEnumObjectFromArray(['small', 'medium']);

FsRadio.propTypes = {
  ...FsWrappersSharedProptypes,
  checked: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(Object.keys(FsRadio.SIZES)),
  onClick: PropTypes.func,
};

export default FsRadio;
